import { TransformationPageProvider } from "../../context/TransformationPageContext";
import ServicePageLayout from "./ServicePageLayout";

export default function Transformation() {
  return (
    <TransformationPageProvider>
      <ServicePageLayout />
    </TransformationPageProvider>
  );
}
